import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { BankNote } from '../../entities/control-tables/bank-note';


export class BankNoteRequest extends BaseRequest {
  
  bankNote : BankNote;
  
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.bankNote = new BankNote();
  }
}